// ==LICENSE-BEGIN==
// Copyright 2017 European Digital Reading Lab. All rights reserved.
// Licensed to the Readium Foundation under one or more contributor license agreements.
// Use of this source code is governed by a BSD-style license
// that can be found in the LICENSE file exposed on Github (readium) in the project repository.
// ==LICENSE-END==

import { IPropertyConverter, JsonValue } from "ta-json-x";

export class JsonDateConverter implements IPropertyConverter {
    public serialize(property: Date | undefined): JsonValue {
        return property ? property.toISOString() : "Invalid Date";
    }

    public deserialize(value: JsonValue): Date | undefined {
        const date = new Date(value as string);
        return isNaN(date.getTime()) ? undefined : date;
    }

    public collapseArrayWithSingleItem(): boolean {
        return false;
    }
}
